import { render } from "./SupportedFeatures.vue?vue&type=template&id=21ecaea9"
import script from "./SupportedFeatures.vue?vue&type=script&lang=js"
export * from "./SupportedFeatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__